import { Link } from "react-router-dom";
import { XCircle, ArrowUpRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="page-payment-cancel" className="pt-40 pb-24 min-h-[70vh]">
      <div className="mx-auto max-w-[720px] px-6 text-center">
        <div className="w-20 h-20 rounded-full bg-blush mx-auto flex items-center justify-center">
          <XCircle size={40} className="text-[hsl(var(--onyx))]" />
        </div>
        <div className="overline mt-8">Checkout cancelled</div>
        <h1 className="font-display text-5xl sm:text-6xl mt-3 tracking-tight text-balance">
          No worries — <span className="italic font-light">nothing was charged.</span>
        </h1>
        <p className="mt-6 text-[hsl(var(--onyx)/0.65)]">
          Whenever you're ready, your course is waiting.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link to="/academy" data-testid="cancel-back-academy" className="btn-pill btn-primary">
            Back to courses <ArrowUpRight size={16} />
          </Link>
          <Link to="/" className="btn-pill btn-outline">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
